const SvgIcon = ({
  src,
  mobileSrc = "",
  onClickFn = () => {},
  onMouseEnterFn = () => {},
  onMouseLeaveFn = () => {},
  noFilterOnLight = false,
  useCurrentColor = false,
  classNames = "",
  style: externalStyle = undefined,
  ...props
}) => {
  if (useCurrentColor) {
    return (
      <span
        onClick={(e) => (onClickFn ? onClickFn(e) : null)}
        onMouseEnter={(e) => (onMouseEnterFn ? onMouseEnterFn(e) : null)}
        onMouseLeave={(e) => (onMouseLeaveFn ? onMouseLeaveFn(e) : null)}
        {...props}
        className={`svg-icon-mask ${classNames}`}
        style={{
          display: "inline-block",
          backgroundColor: "currentColor",
          WebkitMaskImage: `url(${src})`,
          maskImage: `url(${src})`,
          WebkitMaskSize: "contain",
          maskSize: "contain",
          WebkitMaskRepeat: "no-repeat",
          maskRepeat: "no-repeat",
          WebkitMaskPosition: "center",
          maskPosition: "center",
          ...externalStyle,
        }}
      />
    );
  }

  return (
    <picture
      onClick={(e) => (onClickFn ? onClickFn(e) : null)}
      onMouseEnter={(e) => (onMouseEnterFn ? onMouseEnterFn(e) : null)}
      onMouseLeave={(e) => (onMouseLeaveFn ? onMouseLeaveFn(e) : null)}
      {...props}
      className={classNames}
      style={externalStyle}
    >
      <img
        className={`${
          noFilterOnLight === true ? "filter-none!" : undefined
        } mobile-hidden`}
        src={src}
      />
      <img
        className={`${
          noFilterOnLight === true ? "filter-none!" : undefined
        } only-show-mobile`}
        src={mobileSrc || src}
      />
    </picture>
  );
};

export default SvgIcon;
